import axios from "axios";

// baseURL is the URL of the hosted server
// this baseURL is used for production
export default axios.create({
  baseURL: "https://www.markkeeble.ca/api/"
});
